module.exports = __webpack_public_path__ + "img/weddings_21_H.0df2bd43.webp";